<div class="section not-found">
  <div class="bg">{{bgChars}}</div>
  <div class="page center">
    <h1>{{errorTitle}}</h1>
    <p>
      <ng-content></ng-content>
    </p>
  </div>
</div>
